const config = {

	apiUrl: process.env.REACT_APP_API_URL,
	popbillUrl: process.env.REACT_APP_POPBILL_URL,
	runMode: process.env.REACT_APP_RUN_MODE,
	addressApiKey: process.env.REACT_APP_ADDRESS_API_KEY,
	appMode: process.env.REACT_APP_MODE,
	companyName: process.env.REACT_APP_DEFAULT_COMPANY_NAME,

	popbill_CorpNum: process.env.REACT_APP_POPBILL_CORPNUM,
	popbill_UserId: process.env.REACT_APP_POPBILL_USERID,
	popbill_Sender: process.env.REACT_APP_POPBILL_SENDER
};

export default config;